<template>
  <section class="anchor video" :id="$t('header.nav[0].link')">
    <div class="container">
      <h2 class="video__title" v-html="$t('home.video.title')"></h2>
      <div class="video__content">
        <iframe
          src="https://www.youtube.com/embed/D3mY6hHjoGc?rel=0"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Video"
};
</script>
